import { render, staticRenderFns } from "./person_list.vue?vue&type=template&id=52a3ec3e&scoped=true&"
import script from "./person_list.vue?vue&type=script&lang=js&"
export * from "./person_list.vue?vue&type=script&lang=js&"
import style0 from "./person_list.vue?vue&type=style&index=0&id=52a3ec3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3ec3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a3ec3e')) {
      api.createRecord('52a3ec3e', component.options)
    } else {
      api.reload('52a3ec3e', component.options)
    }
    module.hot.accept("./person_list.vue?vue&type=template&id=52a3ec3e&scoped=true&", function () {
      api.rerender('52a3ec3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/inspection_center/form/person_list.vue"
export default component.exports